import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import configBackground from '../wob-background-menu'
import BaseGaugeConfig from '../base-gauge-config'
import _ from 'lodash'
import {SCORECARDS} from '../../../components/sections'

const SpeedometerConfig = BaseGaugeConfig.extend({

	/** @type {SpeedometerModel} */
	model: null,

	typeSpecificTargets: function (hasTemplate) {
		let target = []

		// if this is a template copy node, there's nothing to configure
		if (this.model.wob.get('hasTemplate')) {
			return []
		}

		target.push(this.createSetNameOption())
		target.push(this.createDataSourceOption())
		// #58603 for the scorecards section, thresholds are defined on the
		// scorecard node, not on the dashboard
		if (this.model.section() != SCORECARDS) {
			target.push(this.createThresholdsOption())
		}
		target.push(configBackground(this.model.properties))
		// the options come from this.getShowingOptions below
		target.push(this.createShowingOption())

		return target
	},

	getShowingOptions: function() {
		let showingOptions =
			BaseGaugeConfig.prototype.getShowingOptions.apply(this, arguments)

		if (this.model.metricish()) {
			let thresholdModes = this.model.validThresholdModes()

			if (thresholdModes.length === 2) {
				// If exactly 2 options (e.g. 'none' and 'default'), just make it a toggle
				showingOptions.push({
					label: 'scorecards.node.metric.thresholds',
					contentView: BootslideMenu.WidgetToggleProperty.extend({
						property: {
							label: 'scorecards.node.metric.thresholds',
							name: 'thresholdMode'
						},
						val() {
							return this.model.get('thresholdMode') === 'default'
						},
						updateModel() {
							// Since we're working with a simple on/off toggle, set everything to be
							// either 'none' or 'default'
							let newMode = this.val() ? 'none' : 'default'

							this.options.widgetUpdater.setProperty('thresholdMode', newMode)
						}
					}),
					model: this.model.properties
				})
			} else if (thresholdModes.length > 2) {
				// If more than 2 options, make it a submenu
				let submenu = thresholdModes.map(mode => {
					return {
						label: mode.label,
						contentView: BootslideMenu.WidgetMultipleChoiceOption.extend({
							label: mode.label,
							value: mode.value,
							property: 'thresholdMode',
							updateModel() {
								this.options.widgetUpdater.applyUpdate(widget => {
									// The user is selecting based on the mode's "label", but that label
									// may represent different values for thresholdMode.
									//
									// For example, 'default' is 'Goal/Red Flag' for '3 Color' metrics,
									// but 'default' is 'Best' for '2 Color Stabilize' metrics.
									//
									// So instead of setting every speedometer to the same 'thresholdMode'
									// value, set it to the mode for each widget that matches the selected mode's
									// label. If there is no matching label, do nothing.
									let matchingMode = _.find(widget.validThresholdModes(), m => m.label === mode.label)
									if (matchingMode) {
										widget.properties.set('thresholdMode', matchingMode.value)
									}
								}, { types: [ 'speedometer' ] })
							}
						}),
						model: this.model.properties
					}
				})

				showingOptions.push({
					label: 'scorecards.node.metric.thresholds',
					target: submenu
				})
			}

			// Note: if less than 2 threshold mode options, don't bother giving
			// the config option
		}

		return showingOptions
	}

})

export default SpeedometerConfig

SpeedometerConfig.__filename__ = 'dashboards/widgets/speedometer/speedometer-config.js'
